var React = require('react');

function ExpandLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.44.44a1.5 1.5 0 010 2.12L15.001 24l21.44 21.44a1.5 1.5 0 01-2.122 2.12L12.881 26.123h-.001a2.997 2.997 0 01-.003-4.24v-.001l.002-.002L34.32.439a1.5 1.5 0 012.121 0zM15 24v-.001m-.002.004L15 24"}));
}

ExpandLeft.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ExpandLeft;

ExpandLeft.default = ExpandLeft;
